import { Manager, Client, ProfileType } from '@/api/profile';
import { Module } from 'vuex';
import { rootState } from '../state';
import { $fetch } from '@/api/fetch';
import REQ_URL from '@/consts/req-url';
import storageObservable from '@/api/storageObservable';
import updateData from '@/api/updateData';
import { profileAbb, profileColor } from '@/api/graphicIdentifier';

interface ManagerClientsBody {
    pageInfo: {
        curr: number,
        of: number
    }
    clients: Client[]
}

const state = {
    isAuth: false,
    profileType: '' as 'client' | 'manager',
    managerInfo: new Manager(),
    clientInfo: new Client(),
}

export const profileStore: Module<typeof state, typeof rootState> = {
    state,
    mutations: {
        setManagerInfo(state, profile: Manager) {
            state.managerInfo = profile
        },
        setClientInfo(state, profile: Client) {
            profile.otgr = +profile.otgr;
            state.clientInfo = profile

        },
        setAuthStatus(state, status: boolean) {
            state.isAuth = status
        },
        setProfileType(state, type: ProfileType) {
            state.profileType = type
        },
        updateProfile(state, props) {
            switch (state.profileType) {
                case 'manager':
                    updateData(state.managerInfo, props)
                    break;
                case 'client':
                    updateData(state.clientInfo, props)
                    break;
            }
        },
        /**
         * 
         * @param state 
         * @param param1 id это email или c1code
         */
        updateManagerClient(state, props: Client) {
            updateData(state.clientInfo, props)
            storageObservable.emit('currentManagerClient', state.clientInfo, false)
        }
    },
    actions: {
        setProfile(c, profile: Manager | Client) {
            switch (profile.type) {
                case 'manager':
                    c.commit('setManagerInfo', profile)
                    let clientProfileJSON = localStorage.getItem('currentManagerClient')
                    if (clientProfileJSON) {
                        let clientProfile: Client = JSON.parse(clientProfileJSON)
                        if (clientProfile.manager && clientProfile.manager.id === c.state.managerInfo.id)
                            c.dispatch('setManagerClientProfile', clientProfile)
                        else
                            localStorage.removeItem('currentManagerClient')
                    }
                    break;
                case 'client':
                    let cart = profile.cart ? profile.cart : {
                        token: profile.c1code
                    }
                    profile.cart = ""
                    //cached - профиль отдан сервис-воркером из idb, см. sw.js
                    let cached = (profile as any).cached
                    delete (profile as any).cached
                    c.commit('setClientInfo', profile)
                    c.dispatch(cached ? 'setCachedBasket' : 'setServerBasket', cart)
                    break;
                default:
                    break;
            }
            c.commit('setAuthStatus', true)
            c.commit('setProfileType', profile.type)
            c.dispatch('setDeferredStorage')
            c.dispatch('returnRejectedOrders')
            c.dispatch('setSettlementAccounts')
            c.dispatch('setSiteConfig')
        },
        async updateProfile(c, props: any) {
            try {
                let data = await $fetch<undefined>(REQ_URL.UPDATE_PROFILE, {
                    method: 'PATCH',
                    body: JSON.stringify(props)
                })
                if (data.error) throw new Error(data.error)
                c.commit('updateProfile', props)
                storageObservable.emit('updateProfile', props)
                return true
            } catch (error) {
                throw error
            }
        },
        setManagerClientProfile(c, profile: Client) {
            c.dispatch('setManagerClientProfileSilent', profile)
            storageObservable.emit('currentManagerClient', profile, false)
            //корзина в profile - снимок из списка клиентов или localStorage, клиент мог изменить её после этого
            c.dispatch('refreshBasket')
            c.dispatch('returnRejectedOrders')
        },
        setManagerClientProfileSilent(c, profile: Client) {
            let cart = profile.cart ? profile.cart : {
                token: profile.c1code
            };
            let cloneProfile = JSON.parse(JSON.stringify(profile))
            delete cloneProfile.cart;
           
            c.commit('setClientInfo', cloneProfile)
            c.dispatch('setBasket', cart)
        },
        exitManagerClient(c) {
            c.dispatch('exitManagerClientSilent')
            localStorage.removeItem('currentManagerClient')
        },
        exitManagerClientSilent(c) {
            c.commit('setClientInfo', new Client())
            c.commit('setBasket', {})
        },
        logout(c) {
            c.commit('setAuthStatus', false)
            c.commit('setProfileType', '')
            c.commit('setManagerInfo', new Manager())
            c.dispatch('exitManagerClient')
        }
    },
    getters: {
        isAuth(state) {
            return state.isAuth
        },
        profileType(state) {
            return state.profileType
        },
        profileTypeView(state) {
            switch (state.profileType) {
                case 'manager':
                    return 'менеджер'
                case 'client':
                    return 'клиент'
                default:
                    break;
            }
        },
        profile(state) {
            if (state.isAuth) {
                switch (state.profileType) {
                    case 'manager':
                        return state.managerInfo
                    case 'client':
                        return state.clientInfo
                    default:
                        return void 0
                }
            }
            return void 0
        },
        profileRegion(state) {
            if (state.isAuth) {
                switch (state.profileType) {
                    case 'manager':
                        return state.managerInfo.region
                    case 'client':
                        return state.clientInfo.manager ? state.clientInfo.manager.region : 'UNI'
                    default:
                        return void 0
                }
            }
            return void 0
        },
        profileColor(state) {
            let fio = '';
            switch (state.profileType) {
                case 'manager':
                    fio = state.managerInfo.fio
                    break;
                case 'client':
                    fio = state.clientInfo.fio
                    break;
                default:
                    return void 0
                    break;
            }
            return profileColor(fio)
        },
        profileAbb(state) {
            let fio = '';
            switch (state.profileType) {
                case 'manager':
                    fio = state.managerInfo.fio
                    break;
                case 'client':
                    fio = state.clientInfo.fio
                    break;
                default:
                    return void 0
            }
            return profileAbb(fio)
        },
        clientProfile(state) {
            return state.clientInfo
        },
        managerInfo(state) {
            switch (state.profileType) {
                case 'manager':
                    return state.managerInfo
                case 'client':
                    return state.clientInfo.manager
            }
        },
    }
}